

















































import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { formatRelativeDate } from '@/filters/formatRelativeDate'
import Questionnaire from '@/components/Programmation/Questionnaire.vue'
import HasAnswered from '@/components/Programmation/HasAnswered.vue'
import { ApiService } from '@/api/api.service'
import { getBoUrl } from '@/api/http-constants'
import { nickname } from '@/utils/nickname'
import { UserModule } from '@/store/modules/user'
import { getOperation, getOperationID } from '@/api/operations'
import find from 'lodash/find'
import { getNames } from '@/utils/getNames'
import { getModuleIcon } from '@/utils/getModuleIcon'

@Component({
    components: {
        SmoothReflow,
        Questionnaire,
        HasAnswered,
    },
    filters: {
        formatRelativeDate,
    },
})
export default class ModuleProgrammation extends Vue {
    @Prop() module: any
    moduleID: number
    showQuestionary = false
    smoothReflowSettings = {
        transitionEvent: {
            selector: 'div',
            propertyName: 'opacity',
        },
    }
    nickname: string
    opeName: string
    opeID: number
    userID: number

    getIcon(type: string): string {
        return getModuleIcon(this.module.type)
    }

    get names(): string[] {
        return getNames(
            this.module,
            this.nickname,
            this.opeName,
            this.opeID,
            this.userID
        )
    }

    get users() {
        return this.module.hasAnswered.map(user => {
            const name = nickname(user.firstname, user.lastname)

            return {
                id: user.id,
                name,
            }
        })
    }

    @Watch('module', { deep: true, immediate: true })
    async onModule() {
        if (!this.module) {
            return
        }

        console.log(JSON.parse(JSON.stringify(this.module)))

        this.moduleID = this.module.id
        this.showQuestionary = false
    }

    async created() {
        await UserModule.Init()
        this.userID = UserModule.userInfos.id
        this.nickname = nickname(
            UserModule.userInfos.firstname,
            UserModule.userInfos.lastname
        )

        const opSlug = getOperation()

        const apiService = new ApiService()
        const allOpResp = await apiService.getAllOpe()
        const allOp = allOpResp.data
        const op: any = find(allOp, {
            slug: opSlug,
        })
        this.opeName = op.name
        this.opeID = await getOperationID()
    }

    done() {
        this.$emit('done')
    }
}
